export type Bonus = {
  number: string
  title: string
  body: string
  /** Optional cover image. Empty = the CSS cover in the product palette. */
  cover?: string
  /** Tailwind bg class for the CSS cover's accent band. */
  accent: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Start Anywhere Season Planner',
    body: 'Starting in January, mid-term or on a 10-week term? Pick your start date and season length, and in 10 minutes you know exactly which week to teach on each day of your calendar.',
    cover:
      'https://cdn.magicpatterns.com/uploads/8RNFVrLmVTVQFKNqM7xnCp/bonus1-mockup-start-anywhere-season-planner.png',
    accent: 'bg-sage',
  },
  {
    number: '02',
    title: 'The 10-Minute Combo Decoder',
    body: 'A simple 4-step routine to go from a Combo Card on paper to dancing it full-out in about 10 minutes, plus a one-page cheat sheet of the 8 most common reading mistakes.',
    cover:
      'https://cdn.magicpatterns.com/uploads/raJP35KFkbA1LXf1bpMYuE/bonus2-mockup-the-10-minute-combo-decoder.png',
    accent: 'bg-coral',
  },
  {
    number: '03',
    title: '40-Week Music Map',
    body: 'For every week: the feel, the song structure that fits the combo and ready-to-paste search phrases, so you find a clean track in minutes instead of scrolling for an hour.',
    cover:
      'https://cdn.magicpatterns.com/uploads/qZCVfnhXFm5bryq4X1mVNA/bonus3-mockup-40-week-music-map.png',
    accent: 'bg-gold',
  },
  {
    number: '04',
    title: 'Style Swap Guide',
    body: 'Swap tables that give any Combo Card a hip-hop, jazz, musical theatre or lyrical flavor. Same counts, same levels, your style.',
    cover:
      'https://cdn.magicpatterns.com/uploads/r2ny3QfLe4kvMGtgofi3Rx/bonus4-mockup-style-swap-guide.png',
    accent: 'bg-lilac',
  },
  {
    number: '05',
    title: 'Studio Wall Kit',
    body: 'Print-and-stick posters for your room: the three level badges, the Stage Grid floor map, a count-to-8 chart and a class rules poster to fill in with your group. Letter and A4.',
    cover:
      'https://cdn.magicpatterns.com/uploads/nLXNhHHcWheSRkV3crHeyr/bonus5-mockup-studio-wall-kit.png',
    accent: 'bg-smoke',
  },
]
